import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';

export class PrivateRoute extends Component {
    constructor(props) {
        super(props);
        this.state = { checking: true, valid: false };
    }

    componentDidMount() {
        const token = localStorage.getItem('token');
        if (!token) {
            this.setState({ checking: false, valid: false });
            return;
        }

        fetch('api/auth/verify', {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then(res => res.json())
            .then(data => this.setState({ checking: false, valid: data.valid }))
            .catch(() => this.setState({ checking: false, valid: false }));
    }

    render() {
        if (this.state.checking) return null;
        if (!this.state.valid) return <Navigate to="/login" />;
        return this.props.children;
    }
}
